import React from "react";

const About = () => {
  return (
    <section id="about" className="about-container">
      <h2>About Me</h2>
      <p>
        Welcome to my corner of the web! I'm Mandi Solone, a budding full stack
        web developer passionate about crafting functional and beautiful digital
        experiences. Beyond coding, I cherish family time and enjoy adventures
        with my four-legged friends. When not at the computer, I recharge at the
        beach or express my creativity through photography. With skills ranging
        from front-end development to back-end, I'm dedicated to continuous
        learning and growth. Explore my work and feel free to reach out – I'm
        thrilled to share my journey in web development with you!
      </p>
    </section>
  );
};

export default About;
